import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, OccEndpointsService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface TCPayload {
  tncVersionNo: string;
}

export interface TNCPayload {
  userId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSite$}`;
  userCurrent$: Observable<string> = this.auth.getUserId();

  public tncVersion = new BehaviorSubject<any>('string');
  tncVersion$: Observable<any>;

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    private occEndpointsService: OccEndpointsService
  ) {
    this.tncVersion$ = this.tncVersion.asObservable();
  }

  getTCVersionStatus(): Observable<any> {
    return this.auth
      .getUserId()
      .pipe(
        switchMap((userCurrent) => {
          return this.http.get(this.occEndpointsService.buildUrl(`/terms-and-conditions/${userCurrent}`));
        })
      )
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }

  updateTC(payload: TCPayload) {
    const params = new HttpParams().set('versionNo', payload.tncVersionNo);

    return this.auth
      .getUserId()
      .pipe(
        switchMap((userCurrent) => {
          return this.http.put(this.occEndpointsService.buildUrl(`/users/${userCurrent}/tncAcceptedDate`), null, {
            params,
          });
        })
      )
      .pipe(map((data) => data));
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
